import React from "react";
import { ActiveIntegrationsProvider } from "src/scenes/dashboard/active-integrations-provider";
import PersonalProfileCard from "src/scenes/personal-profile/personal-profile-card";

const PersonalProfile = () => {
    return (
        <ActiveIntegrationsProvider>
            <PersonalProfileCard />
        </ActiveIntegrationsProvider>
    );
};

export default PersonalProfile;
